import RoundIconLabelUnit from '@/components/ui/RoundIconLabelUnit/RoundIconLabelUnit';
import Link from 'next/link';
import { CreatorListItem } from '../../types';
import styles from './BizCreatorList.module.scss';

function BizCreatorList({
  creators,
}: {
  creators: Array<CreatorListItem>;
}) {
  return (
    <div className={styles.componentStyle}>
      {creators.map((creator) => (
        <Link
          key={creator.id}
          className={styles.listItem}
          href={`/e-commerce/biz-team-creator/creator/${creator.urlSlug}`}
        >
          <RoundIconLabelUnit
            iconImageUrl={creator.iconUrl}
            labelText={creator.name}
            subLabelText={creator.bizTeam.length > 0 ? creator.bizTeam[0].name : ''}
          ></RoundIconLabelUnit>
        </Link>
      ))}
    </div>
  );
}

export default BizCreatorList;
